module.exports = __webpack_public_path__ + "static/project-2-edbfa14c5dd06d568b38e45ae3b1692f.jpg";